



































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

//Mixins
import RequestPromises from "@/mixins/requestPromises";

// Data/Enums
import { ISegmentTypes, INewSegmentRouteTypes } from "@/data/enums/segments";
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";
import { ISegment } from "@/models/segments";
import { ActionTypes } from "@/data/enums";
import SegmentResultsListing from "@/components/app/admin/segments/segmentResultsListing.vue";
import { DefaultFilters as DefaultClientFilters } from "@/data/filters/client";
import { DefaultSorters as DefaultClientSorters } from "@/data/sorters/client";
import { DefaultCProdFilters } from "@/data/filters/contractProducts";
import { DefaultCProdSorters } from "@/data/sorters/contractProducts";
import { IFilter, ISorter } from "@/models/tables";
import { ListDisplayMode } from "@/data/constants";
import { UserMetaKeys } from "@/data/enums/users";

@Component({
  components: {
    SegmentResultsListing,
    "contracts-products-segment-results-table": () =>
      import("@/components/app/global/contractProducts/productsTable.vue")
  },
  computed: {
    ...mapState({
      segment(state: IState, getters) {
        return getters[`data/single`]({
          id: this.segmentId,
          storeModule: DataModules.SEGMENTS
        });
      }
    })
  }
})
export default class SegmentResultsModal extends Mixins(RequestPromises) {
  // Props

  @Prop({ required: true })
  public segmentId!: ISegment["id"];

  @Prop({ required: true })
  public segmentType!: ISegmentTypes;

  // Data

  public segment!: ISegment;
  public isLoading = false;
  public isReloading = false;
  public hasRequestError = false;
  public availableFilters = () => [] as IFilter[];
  public availableSorters = () => [] as ISorter[];

  // Computed

  public get isClientsSegment() {
    return this.$_.startsWith(this.segmentType, ISegmentTypes.CLIENT);
  }

  public get isContractsProductsSegment() {
    return this.$_.startsWith(
      this.segmentType,
      ISegmentTypes.CONTRACTS_PRODUCTS
    );
  }

  public get defaultDisplayMode() {
    if (this.isClientsSegment) return ListDisplayMode.TABLE;
    else if (this.isContractsProductsSegment) return ListDisplayMode.GRID;
    return ListDisplayMode.TABLE;
  }

  public get displayModeStoragePath() {
    if (this.isClientsSegment) return UserMetaKeys.UI_CLIENTS_DISPLAY_MODE;
    else if (this.isContractsProductsSegment)
      return UserMetaKeys.UI_CATALOGUE_DISPLAY_MODE;
    return undefined;
  }

  public get routeName() {
    switch (this.segmentType) {
      case ISegmentTypes.CLIENT:
        return INewSegmentRouteTypes.CLIENT;
      case ISegmentTypes.CONTRACTS_PRODUCTS:
        return INewSegmentRouteTypes.CONTRACTS_PRODUCTS;
      case ISegmentTypes.CONTRACTS_PRODUCTS_SALE:
        return INewSegmentRouteTypes.CONTRACTS_PRODUCTS_SALE;
      case ISegmentTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION:
        return INewSegmentRouteTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION;
      case ISegmentTypes.ORDER:
        return INewSegmentRouteTypes.ORDER;
      default:
        return INewSegmentRouteTypes.CLIENT;
    }
  }

  // Life-cycle methods

  public created() {
    if (!this.$userCan("get_segment")) return;
    this.isLoading = true;
    this.loadData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: DataModules.SEGMENTS,
      vm: this
    });
  }

  // Methods

  public async loadData() {
    try {
      await this.getSegment();
      this.loadFiltersAndSorters();
      this.hasRequestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.hasRequestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public loadFiltersAndSorters() {
    if (this.segment?.type === ISegmentTypes.CLIENT) {
      this.availableFilters = DefaultClientFilters;
      this.availableSorters = DefaultClientSorters;
    } else if (
      [
        ISegmentTypes.CONTRACTS_PRODUCTS,
        ISegmentTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION,
        ISegmentTypes.CONTRACTS_PRODUCTS_SALE
      ].includes(this.segment.type)
    ) {
      this.availableFilters = DefaultCProdFilters;
      this.availableSorters = DefaultCProdSorters;
    }
  }

  public getSegment() {
    return this.$store.dispatch(`data/${DataModules.SEGMENTS}/get`, {
      id: this.segmentId,
      ignoreStored: this.isReloading,
      vm: this
    });
  }

  public openManageSegmentModal() {
    return this.$store.dispatch(
      `data/${DataModules.SEGMENTS}/openManageSegmentModal`,
      {
        props: {
          ...this.$props,
          actionType: ActionTypes.UPDATE
        }
      }
    );
  }
}
